import { render, staticRenderFns } from "./customDateAttendanceMarking.vue?vue&type=template&id=6532b578"
import script from "./customDateAttendanceMarking.vue?vue&type=script&lang=js"
export * from "./customDateAttendanceMarking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports